// School class new/edit modal form — dynamic behaviour
// Loaded as a pack (main-page nonce) and initialised via the ark:modal:loaded
// custom event dispatched by modals.js after each modal is shown.

(function () {

  // ── Helpers ──────────────────────────────────────────────────────────────

  function isKOrFirst() {
    var val = $('#school_class_grade_level').val();
    return val === 'kindergarten' || val === 'first';
  }

  function theologyWrapper() {
    return $('#subject_list').find('input[type="checkbox"][value="1"]').closest('.form-check');
  }

  function updateTextbookByTheology() {
    var $theology = $('#subject_list').find('input[type="checkbox"][value="1"]');
    var show = $theology.length && $theology.is(':checked') && !isKOrFirst();
    $('#textbook-info').toggle(show);
  }

  function applyGradeLevelSubjectRules() {
    var $wrap = theologyWrapper();

    if (!$wrap.length) {
      $('#textbook-info').hide();
      return;
    }

    var onlyTheologyRaw = $('#subject_list').data('only_theology');
    var onlyTheology = (onlyTheologyRaw === true) ||
                       (String(onlyTheologyRaw || '').toLowerCase() === 'true');

    if (isKOrFirst()) {
      $wrap.find('input').prop('checked', false).prop('disabled', true);
      $wrap.hide();
      $('#textbook-info').hide();
    } else if (onlyTheology) {
      // Keep theology disabled (and checked) — do not let this branch re-enable it
      $wrap.find('input').prop('disabled', true);
      $wrap.show();
      updateTextbookByTheology();
    } else {
      $wrap.find('input').prop('disabled', false);
      $wrap.show();
      updateTextbookByTheology();
    }
  }

  // ── Subject list builder (called after testing-center AJAX) ──────────────

  function CreateSubjectList(response) {
    var subjectListContainer = $('#subject_list');
    subjectListContainer.empty();

    var disallowTheology = isKOrFirst();

    if (response.only_theology && !disallowTheology) {
      var formCheckDiv = $('<div>', { class: 'form-check' });
      var theologyCheckbox = $('<input>', {
        type: 'checkbox',
        id: 'subject_1',
        name: 'school_class[subject_area_ids][]',
        value: '1',
        checked: true,
        disabled: true,
        class: 'form-check-input'
      });
      var theologyLabel = $('<label>', {
        for: 'subject_1',
        text: 'Theology',
        class: 'form-check-label'
      });
      formCheckDiv.append(theologyCheckbox).append(theologyLabel);
      subjectListContainer.append(formCheckDiv);
      $('#textbook-info').show();
    } else {
      (response.subjects || []).forEach(function (subject) {
        if (disallowTheology && subject.id === 1) return;

        var formCheckDiv = $('<div>', { class: 'form-check' });
        var checkbox = $('<input>', {
          type: 'checkbox',
          id: 'subject_' + subject.id,
          name: 'school_class[subject_area_ids][]',
          value: subject.id,
          class: 'form-check-input'
        });
        var label = $('<label>', {
          for: 'subject_' + subject.id,
          text: subject.name,
          class: 'form-check-label'
        });
        formCheckDiv.append(checkbox).append(label);
        subjectListContainer.append(formCheckDiv);
      });

      $('#textbook-info').hide();

      subjectListContainer.find('input[type="checkbox"]').on('change', function () {
        updateTextbookByTheology();
      });
    }

    applyGradeLevelSubjectRules();
  }

  // Expose for any legacy callers
  window.CreateSubjectList = CreateSubjectList;

  // ── Per-modal initialisation ──────────────────────────────────────────────
  // Called every time the school class form is injected into the DOM.

  function initializeSchoolClassModal() {
    var checkboxes = $('input[name="school_class[subject_area_ids][]"]:visible');
    var textbookInfoSection = $('#textbook-info');

    var onlyTheologyRaw = $('#subject_list').data('only_theology');
    var onlyTheology = (onlyTheologyRaw === true) ||
                       (String(onlyTheologyRaw).toLowerCase() === 'true');

    if (onlyTheology && !isKOrFirst()) {
      var theologyCheckbox = checkboxes.filter(function () { return $(this).val() === '1'; });
      if (theologyCheckbox.length) {
        theologyCheckbox.prop('checked', true).prop('disabled', true);
      }
      textbookInfoSection.show();
      checkboxes.each(function () {
        if ($(this).val() !== '1') { $(this).parent().hide(); }
      });
    } else {
      textbookInfoSection.hide();
    }

    applyGradeLevelSubjectRules();

    // Namespaced events prevent double-binding when the modal is re-opened
    $('form').off('submit.school_class').on('submit.school_class', function () {
      if (onlyTheology && !isKOrFirst()) {
        $('<input>').attr({
          type: 'hidden',
          name: 'school_class[subject_area_ids][]',
          value: '1'
        }).appendTo(this);
      }
    });

    $('#school_class_testing_center').off('change.school_class').on('change.school_class', function () {
      var testingCenterId = $(this).val();
      if (testingCenterId) {
        $.ajax({
          url: '/admin/testing_centers/' + testingCenterId + '/subjects',
          method: 'GET',
          dataType: 'json',
          success: function (response) {
            CreateSubjectList(response);
          },
          error: function (xhr, status, error) {
            console.error('AJAX error:', error);
          }
        });
      }
    });
  }

  // ── Persistent delegated handlers (safe to register once at page load) ───

  $(document).on('change', '#school_class_grade_level', function () {
    applyGradeLevelSubjectRules();
  });

  $(document).on('change', 'input[name="school_class[subject_area_ids][]"]', function () {
    updateTextbookByTheology();
  });

  // ── Boot on modal open ────────────────────────────────────────────────────

  $(document).on('ark:modal:loaded', function () {
    if (!$('#school_class_grade_level').length) return;
    initializeSchoolClassModal();
  });

}());
